export const CoinIcon = ({
  strokeColor = "var(--color-txt-secondary)",
  width= "26",
  height= "26",
  ...props
}: any) => (
  <svg {...props} width={width} height={height} viewBox="0 0 26 26" fill="none">
    <g id="vuesax/linear/coin">
      <g id="coin">
        <path
          id="Vector"
          d="M8.66675 12.35C8.66675 13.1842 9.31675 13.8667 10.1076 13.8667H11.7326C12.4259 13.8667 12.9892 13.2708 12.9892 12.545C12.9892 11.7542 12.6426 11.4725 12.1334 11.2883L9.53341 10.3783C9.01341 10.1942 8.66675 9.9125 8.66675 9.12167C8.66675 8.39584 9.23008 7.8 9.92341 7.8H11.5484C12.3501 7.81084 13.0001 8.4825 13.0001 9.31667"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M10.8333 13.9208V14.7225"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M10.8333 6.94417V7.78917"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M10.8226 19.4783C15.6031 19.4783 19.4784 15.603 19.4784 10.8225C19.4784 6.04202 15.6031 2.16667 10.8226 2.16667C6.0421 2.16667 2.16675 6.04202 2.16675 10.8225C2.16675 15.603 6.0421 19.4783 10.8226 19.4783Z"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M14.0618 21.5367C15.0368 22.9125 16.6293 23.8117 18.4493 23.8117C21.4068 23.8117 23.8118 21.4067 23.8118 18.4492C23.8118 16.6508 22.9234 15.0583 21.5693 14.0833"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);
